import { FullBrand, Brand } from "~src/types/brand";

export const followerCount = (brand: Brand | FullBrand | null) => {
  const likes = brand?.fblikes || 0;
  const followers = brand?.instagram_followers || 0;
  return (likes + followers).toLocaleString("en-US", {
    useGrouping: true,
  });
};

export const reviewsCount = (brand: Brand | FullBrand | null) => {
  const reviewCount = brand?.total_reviews_count || 0;
  return reviewCount.toLocaleString("en-US", {
    useGrouping: true,
  });
};
